





























import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import { sectionCoreProps } from '../mixins/sectionCore'
import { ButtonAction } from '../contracts/ButtonHeroAction'
import BlockButtons from '../components/BlockButtons.vue'
import { emptySectionData, SectionData } from '@/contracts/SectionData'

export default defineComponent({
  name: 'SectionImageBackground',
  components: { BlockButtons },
  mixins: [sectionCoreProps],
  props: {
    sectionData: {
      type: Object as PropType<SectionData>,
      default: () => emptySectionData(),
    },
    actionButtons: {
      type: Array as PropType<ButtonAction[]>,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    background: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const styles = computed(() => ({
      '--section-background': props.background,
    }))

    return {
      styles,
    }
  },
})
